import FormSetNumber from '../../../../components/form-set-number/form-set-number'
import { onAnyStandardCell, renderCalcPos } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const formSetColumn: CalculationColumn = {
    dataIndex: ['shipment_position', 'shipment', 'form_set', 'id'],
    title: (
        <>
            Набор <br />
            форм
        </>
    ),
    width: 70,
    onCell: onAnyStandardCell,
    render: renderCalcPos(r => {
        const formSet = r.shipment_position?.shipment?.form_set
        if (!formSet?.documentId) return null
        return <FormSetNumber formSet={formSet} />
    }),
}
